import { CurrencyPipe } from '@angular/common';
import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { switchMap, switchMapTo, take, takeUntil, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { NotificationsService } from '../../../core/notifications/notifications.service';
import { DataManagerService } from '../../../core/services/data-manager.service';
import { ManagerService } from '../../../core/services/manager.service';
import { removeEmpty } from '../../../shared/helpers/helpers';
import { Settings } from '../../../shared/models';
import { CurrencyInfo } from '../../../shared/models/currency-info';
import { GatewayInfo, GatewayInfoLang, GatewaysInfo } from '../../../shared/models/gateway-info';
import { User } from '../../../shared/models/user';
import { CurrencyMultiplierPipe } from '../../../shared/utils/currency-multiplier.pipe';


const Moralis = require('moralis').default;
const { EvmChain } = require('@moralisweb3/common-evm-utils');
declare const window: any;


import Web3 from 'web3';
import { AbiItem } from 'web3-utils';
import { ConfigService } from '../../../core/services/config.service';
import { MatDialog } from '@angular/material/dialog';
import { GenericTextDialog } from '../../../core/dialogs/generic-text-dialog/generic-text-dialog.component';
import { EditProfileComponent } from '../../dialogs/edit-profile/edit-profile.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.scss']
})
export class GatewayComponent implements OnInit, OnDestroy {

  @Input() deposit: boolean;
  @Input() withdraw: boolean;

  settings: Settings;
  gatewaysInfo: GatewayInfo[];
  user: User;
  selectedGateway: GatewayInfo;
  form: FormArray;
  currencyInfo: CurrencyInfo[];
  destroy$ = new Subject<boolean>();

  chooseGateway = new FormControl('')

  env = environment

  config;
  descriptionHtml: SafeHtml | string = '';

  constructor(
    private notificationService: NotificationsService,
    private managerService: ManagerService,
    private translateService: TranslateService,
    private fb: FormBuilder,
    private dataManagerService: DataManagerService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
  ) {
    this.config = this.configService.config;

  }

  get showDepositTiles(): boolean {
    return !!this.deposit && !!this.config?.depositGatewayTiles;
  }

  @HostBinding('class.tiles-layout')
  get tilesLayoutHost(): boolean {
    return this.showDepositTiles;
  }

  ngOnInit(): void {
    this.chooseGateway.valueChanges.subscribe(value => {
      this.onGetwaySelected(this.gatewaysInfo.find(el => el.name === value))
    })

    this.managerService.settings$
      .pipe(
        tap(settings => this.settings = settings),
        switchMap(() => this.managerService.user$),
        tap(user => this.user = user),
        switchMap(() => this.managerService.currencyInfo$),
        tap(currencyInfo => this.currencyInfo = currencyInfo),
        switchMap(() => this.managerService.gatewaysInfo$),
        takeUntil(this.destroy$)
      )
      .subscribe({
        next: gatewaysInfo => {
          //  this.chooseGateway.reset()
          const gatewaysInfoCopy = JSON.parse(JSON.stringify(gatewaysInfo))

          if (this.withdraw) {
            this.gatewaysInfo = this.formatGatewayInfo(gatewaysInfoCopy.withdraw)
            this.onGetwaySelected(this.gatewaysInfo[0])
          } else if (this.deposit) {

            this.gatewaysInfo = this.formatGatewayInfo(gatewaysInfoCopy.deposit)

            this.onGetwaySelected(this.gatewaysInfo[0])
          }

        }
      })
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }


  formatGatewayInfo(data: GatewayInfo[]) {
    return data.filter(el => (el.currencyId === -1 || el.currencyId === this.user.selectedCurrency.Id) && (el.trustLevel === -1 || el.trustLevel === this.settings.TrustLevel * 1)) // *1 convert to number
      .map(el => {

        el.currentLangDisplayName = this.findCurentLang(el.displayName)
        el.currentLangDescription = this.findCurentLang(el.description)

        el.fields.map(el => {
          el.currentLangHing = this.findCurentLang(el.hint)
          return el
        })
        return el
      })
  }

  onGetwaySelected(gateway: GatewayInfo) {
    if (!gateway) { return }

    this.chooseGateway.setValue(gateway.name, { emitEvent: false })
    this.selectedGateway = gateway
    this.descriptionHtml = this.toDescriptionHtml(gateway.currentLangDescription)

    this.form = this.fb.array([])

    for (const item of this.selectedGateway.fields) {

      this.form.push(this.fb.group({
        fieldName: [item.fieldName],
        hint: [item?.currentLangHing],

        typeOfView: [item.typeOfView],
        regex: [item.regex],
        shouldCacheIt: [item.shouldCacheIt],
        required: [item.required],
        isAmountField: [item.isAmountField],
        values: [item.values],
        inputType: [item.inputType === 'number' ? 'number' : 'text'],

        value: [item.typeOfView === 'dropdown' && item.values && item.values.length > 0 ? item.values[0] : null, item.required ? Validators.required : '']
      }))
    }

  }


  hasLogo(gateway: GatewayInfo): boolean {
    return !!gateway?.logo && gateway.logo.trim().length > 0;
  }

  private toDescriptionHtml(value: string): SafeHtml | string {
    if (!value) {
      return '';
    }

    const html = value.replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  findCurentLang(data: GatewayInfoLang[]): string {

    if (!data || data.length === 0) { return }

    let lang = data.find(el => el.langId === this.translateService.currentLang || el.langId.toLowerCase().includes(this.translateService.currentLang)) // find by current language

    if (!lang) { // if current language doesnt exist first try to find english otherwise set first available language
      lang = data.find(el => el.langId === 'en')
      if (!lang) {
        lang = data[0]
      }
    }
    return lang.value
  }

  onRequest() {

    if (this.withdraw) {
      let convertedAmount

      let data = {}
      for (const item of this.form.value) {
        if (item.required && !item.value) {
          this.notificationService.showError(`The ${item?.hint} field is required`);

          return
        }

        if (item.isAmountField && item.inputType === 'number') { //&& item.typeOfView === 'text'
          if (item.value <= 0) {
            this.notificationService.showError('Amount below minimum');
            return;
          }
          convertedAmount = CurrencyMultiplierPipe.prototype.transform(+item.value, this.user.selectedCurrency);
        } else {
          data[item.fieldName] = item.value
        }
      }

      console.log("#4", convertedAmount)

      this.dataManagerService.sendWithdrawalRequest(
        this.selectedGateway.name,
        convertedAmount ? convertedAmount : 0,
        this.user.selectedCurrency.Id,
        JSON.stringify(removeEmpty(data))
      );


    } else if (this.deposit) {

      if (!this.user.memberProfile.ProfileUpdated) {
        const dialogRef = this.dialog.open(GenericTextDialog);


        dialogRef.componentInstance.textHeader = 'Profile Update';
        dialogRef.componentInstance.textBody = 'You should update your profile in order to make the first deposit.';
        dialogRef.componentInstance.textAcceptBtn = 'Update Profile ';
        dialogRef.componentInstance.textDismissBtn = 'Cancel'

        dialogRef.componentInstance.enableAccept = true;
        dialogRef.componentInstance.enableClose = true;

        dialogRef.afterClosed()
          .pipe(take(1))
          .subscribe(confirmed => {
            if (confirmed) {

              this.dialog.open(EditProfileComponent, {
                width: '300px',
                data: this.user.memberProfile
              })
            }
          })
        return
      }

      let amount
      let convertedAmount
      let promocode

      for (const item of this.form.value) {
        if (item.required && !item.value) {
          this.notificationService.showError(`The ${item?.hint} field is required`);

          return
        }
        if (item.isAmountField) {
          if (item.value <= 0) {
            this.notificationService.showError('Amount below minimum');
            return;
          }
          if (!this.isValidValue(item.value)) { return }
          amount = +item.value
          convertedAmount = CurrencyMultiplierPipe.prototype.transform(+item.value, this.user.selectedCurrency);
        } else if (item.fieldName === 'Str1') {
          promocode = item.value
        }
      }

      if (this.selectedGateway.name.toLocaleLowerCase() === 'metamask') {
        this.metamask(amount ? amount : 10)
          .then()
          .catch()
      } else {
        this.dataManagerService.sendDepositRequest(
          this.selectedGateway.name,
          convertedAmount ? convertedAmount : 10,
          this.user.selectedCurrency.Id,
          promocode
        );
      }



    }

    for (const formControl of this.form.controls) {
      formControl.get('value').reset()
    }
  }


  isValidValue(amount: number) {
    if (amount <= 0) {
      this.notificationService.showError('Amount below minimum');
      return false;
    }

    // if (amount < this.currencyInfo.DepositMin) {
    //   this.notificationService.showError(
    //     `Minimal Deposit value is ${CurrencyPipe.prototype.transform(this.currencyInfo.DepositMin, this.user.selectedCurrency)}`
    //   );
    //   return false;
    // } else if (amount > this.currencyInfo.DepositMax) {
    //   this.notificationService.showError(
    //     `Maximal Deposit value is ${CurrencyPipe.prototype.transform(this.currencyInfo.DepositMax, this.user.selectedCurrency)}`
    //   );
    //   return false;
    // }
    return true;
  }

  async metamask(depositAmount: number) {
    try {
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })

      // Replace the values below with your own
      const providerUrl = 'https://celo-mainnet.infura.io/v3/67812e8ce8ae4f339e356ef7b39a15b5' //'https://mainnet.infura.io/v3/YOUR_PROJECT_ID';
      const usdtContractAddress = '0xdAC17F958D2ee523a2206206994597C13D831ec7';
      const usdtAbi: AbiItem[] = [{ "constant": true, "inputs": [], "name": "name", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_upgradedAddress", "type": "address" }], "name": "deprecate", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "_spender", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "approve", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "deprecated", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_evilUser", "type": "address" }], "name": "addBlackList", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_from", "type": "address" }, { "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transferFrom", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "upgradedAddress", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "balances", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "decimals", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "maximumFee", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "_totalSupply", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "unpause", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "name": "_maker", "type": "address" }], "name": "getBlackListStatus", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }, { "name": "", "type": "address" }], "name": "allowed", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "paused", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "who", "type": "address" }], "name": "balanceOf", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [], "name": "pause", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "getOwner", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "symbol", "outputs": [{ "name": "", "type": "string" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_to", "type": "address" }, { "name": "_value", "type": "uint256" }], "name": "transfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "newBasisPoints", "type": "uint256" }, { "name": "newMaxFee", "type": "uint256" }], "name": "setParams", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "amount", "type": "uint256" }], "name": "issue", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "amount", "type": "uint256" }], "name": "redeem", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "name": "_owner", "type": "address" }, { "name": "_spender", "type": "address" }], "name": "allowance", "outputs": [{ "name": "remaining", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "basisPointsRate", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "name": "", "type": "address" }], "name": "isBlackListed", "outputs": [{ "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "_clearedUser", "type": "address" }], "name": "removeBlackList", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "MAX_UINT", "outputs": [{ "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "name": "newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "name": "_blackListedUser", "type": "address" }], "name": "destroyBlackFunds", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "name": "_initialSupply", "type": "uint256" }, { "name": "_name", "type": "string" }, { "name": "_symbol", "type": "string" }, { "name": "_decimals", "type": "uint256" }], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "amount", "type": "uint256" }], "name": "Issue", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "amount", "type": "uint256" }], "name": "Redeem", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "newAddress", "type": "address" }], "name": "Deprecate", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "feeBasisPoints", "type": "uint256" }, { "indexed": false, "name": "maxFee", "type": "uint256" }], "name": "Params", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "_blackListedUser", "type": "address" }, { "indexed": false, "name": "_balance", "type": "uint256" }], "name": "DestroyedBlackFunds", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "_user", "type": "address" }], "name": "AddedBlackList", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "name": "_user", "type": "address" }], "name": "RemovedBlackList", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "owner", "type": "address" }, { "indexed": true, "name": "spender", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Approval", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "name": "from", "type": "address" }, { "indexed": true, "name": "to", "type": "address" }, { "indexed": false, "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [], "name": "Pause", "type": "event" }, { "anonymous": false, "inputs": [], "name": "Unpause", "type": "event" }]

      const senderAddress = '0xD17AaC4cD9Aba5bEaAa1Ec92026a16a4f76132CE';
      const recipientAddress = '0x9F21B59D4d5749d424519f1a72393792c0402020';

      const web3 = new Web3(providerUrl);

      // Get the contract instance
      const usdtContract = new web3.eth.Contract(usdtAbi, usdtContractAddress);

      // Create the transaction data for the transfer
      const amount = depositAmount * 1000000// web3.utils.toWei('0.00066', 'ether'); // Change to the desired amount
      const transferData = usdtContract.methods.transfer(recipientAddress, amount).encodeABI();

      const gasPrice = await web3.eth.getGasPrice();
      const adjustedGasPrice = Math.round(Number(gasPrice) * 0.005);

      // Create the transaction object
      const txObj = {
        from: accounts[0],
        to: usdtContractAddress,
        gasPrice: web3.utils.toHex(adjustedGasPrice),
        //gasLimit: web3.utils.toHex(0.0001), // Change to an appropriate gas limit
        value: '0x00',
        data: transferData
      };

      // Send the transaction request to Metamask for user approval
      await window.ethereum
        .request({
          method: 'eth_sendTransaction',
          params: [
            txObj
          ],
        })
        .then((txHash) => console.log(txHash))
        .catch((error) => console.error(error));


      // Wait for the transaction to be confirmed on the network
      // const txReceipt = await web3.eth.getTransactionReceipt(txHash);
      //console.log('Transaction receipt:', txReceipt);

    } catch (error) {

    }
  }

}
